import { Box, Text, Group, Progress, Stack } from "@mantine/core";

const BRAND = "var(--mantine-color-primary-7)";

type Props = {
  title: string;
  description?: string;
  sectionIndex: number;
  totalSections: number;
  percentComplete: number;
};

export default function AssessmentHeader({
  title,
  description,
  sectionIndex,
  totalSections,
  percentComplete,
}: Props) {
  return (
    <Box
      style={{
        background: BRAND,
        borderRadius: 10,
        color: "#fff",
      }}
      px={{ base: "md", sm: "xl" }}
      py={{ base: "md", sm: "lg" }}
    >
      <Group justify="space-between" align="flex-start" wrap="nowrap" gap="lg">
        <Stack gap={6} style={{ flex: 1, minWidth: 0 }}>
          <Text fw={700} fz={{ base: 18, sm: 22 }} c="white" lh={1.25}>
            {title}
          </Text>
          {description && (
            <Text fz="sm" c="white" style={{ opacity: 0.9, lineHeight: 1.5 }}>
              {description}
            </Text>
          )}
        </Stack>
        <Stack gap={6} style={{ minWidth: 200 }} align="flex-end">
          <Group gap="xl" wrap="nowrap">
            <Text fz="xs" c="white" style={{ opacity: 0.85, whiteSpace: "nowrap" }}>
              Section {sectionIndex + 1} of {totalSections}
            </Text>
            <Text fz="xs" c="white" fw={600} style={{ whiteSpace: "nowrap" }}>
              {percentComplete}% Complete
            </Text>
          </Group>
          <Progress
            value={percentComplete}
            size={6}
            radius="xl"
            w={220}
            styles={{
              root: { backgroundColor: "rgba(255,255,255,0.25)" },
              section: { backgroundColor: "#ffffff" },
            }}
            aria-label="Overall progress"
          />
        </Stack>
      </Group>
    </Box>
  );
}
